import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const initialSelectedEntities = { MSC: true };

const initialEntityRef = {
    MSC: {
        category: 'Customer',
        disp_name: 'MSC',
    },
};

export function useEntityRef({ activeAccount, apiRootUrl, getAccessToken }) {

    // Entity dropdown state and reference metadata
    const [selectedEntities, setSelectedEntities] = useState(initialSelectedEntities);
    const [entityRef, setEntityRef] = useState(initialEntityRef);
    const [entityRefLoading, setEntityRefLoading] = useState(true);

    // Load available entities for the selector
    useEffect(() => {
        const fetchEntityRef = async () => {
            if (!activeAccount) return;

            try {
                const accessToken = await getAccessToken();

                const response = await axios.get(`${apiRootUrl}/v1/data/entity-ref`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });

                const entitiesData = response.data;
                const entitiesState = {};
                const entityRefData = {};

                // Convert API rows into lookup objects used by the UI
                entitiesData.forEach(entity => {
                    entitiesState[entity.entity] = entity.selected;

                    entityRefData[entity.entity] = {
                        category: entity.category.charAt(0).toUpperCase() + entity.category.slice(1),
                        disp_name: entity.disp_name,
                        weeks: entity.weeks || [],
                    };
                });

                setSelectedEntities(prev =>
                    JSON.stringify(prev) !== JSON.stringify(entitiesState) ? entitiesState : prev
                );

                setEntityRef(prev =>
                    JSON.stringify(prev) !== JSON.stringify(entityRefData) ? entityRefData : prev
                );
            } catch (error) {
                console.error('Error fetching entity reference data:', error);
            } finally {
                setEntityRefLoading(false);
            }
        };

        fetchEntityRef();
    }, [activeAccount, apiRootUrl, getAccessToken]);

    // Keep only one entity selected at a time
    const handleChangeEntities = useCallback((event) => {
        if (entityRefLoading) return;

        const name = event.target.value;

        setSelectedEntities(prev =>
            Object.keys(prev).reduce((obj, key) => {
                obj[key] = key === name;
                return obj;
            }, {})
        );
    }, [entityRefLoading]);

    return {
        selectedEntities,
        setSelectedEntities,
        entityRef,
        entityRefLoading,
        handleChangeEntities,
    };
}